import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Modal, Row, Select} from 'antd';
import {CommandDto} from '../../../api';
import {EditOutlined, MessageOutlined} from "@ant-design/icons";
import DescriptionFormItem from "../../form/DescriptionFormItem";



const DialogCommandModal = ({onCommandCardData, initialData}: { onCommandCardData: Function; initialData?: CommandDto }) => {
    const [form] = Form.useForm();
    const { Option } = Select;
    const [isModalVisible, setIsModalVisible] = useState(false); // State für die Modal-Sichtbarkeit

    useEffect(() => {
        // Wenn initialData vorhanden ist, fülle das Formular mit den initialen Daten
        if (initialData) {
            form.setFieldsValue({
                dialogAccept: initialData.dialogAccept,
                description: initialData.description
            });
        }
    }, [initialData, form]);

    const onFinish = (values) => {
        let command: CommandDto = {dialogAccept: values.dialogAccept, commandType: 'DIALOG', description: values.description};
        onCommandCardData(command);
        setIsModalVisible(false); // Modal schließen
    };

    const onReset = () => {
        form.resetFields();
    };

    // Funktion zum Öffnen des Modals
    const showModal = () => {
        setIsModalVisible(true);
    };

    // Funktion zum Schließen des Modals
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const allDialogOptions = [true, false];

    return (
        <>
            {initialData == null &&
                <div style={{display: 'flex', alignItems: 'stretch', justifyContent: 'stretch'}}>
                  <Button
                      type="primary"
                      onClick={showModal}
                      style={{width: '100%', height: '100%'}}
                  >
                   <MessageOutlined/> Dialog
                  </Button>
                </div>}
            {initialData != null &&
                <Button
                    type="primary"
                    style={{float: 'right'}}
                    onClick={showModal}
                >
                  <EditOutlined/>
                </Button>
            }
            <Modal
                title="Dialog"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                    style={{maxWidth: 600}}
                    layout="vertical"
                >
                    <Form.Item name="dialogAccept" label="Dialog" rules={[{required: true, message: 'Bitte wähle eine Option aus'}]}>
                        <Select
                            placeholder="Wähle eine Dialog-Option"
                            allowClear
                        >
                            {allDialogOptions.map((option, index) => (
                                <Option key={index} value={option}>
                                    {option ? "Accept" : "Dismiss"}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <DescriptionFormItem />
                    <Form.Item>
                        <Row justify="center">
                            <Col style={{marginRight: 5}}>
                                <Button type="primary" htmlType="submit">
                                    {initialData ? "Speichern" : "Hinzufügen"}
                                </Button>
                            </Col>
                            <Col>
                                <Button htmlType="button" onClick={onReset}>
                                    Zurücksetzen
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default DialogCommandModal;
